import React from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
        <div className="footer-links">
          <Link to="/about">About Us</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/faq">FAQs</Link>
          <Link to="/terms">Terms & Conditions</Link>
        </div>
        <p>© 2024 JobsHotSpot. All rights reserved.</p>
      </footer>
  );
};

export default Footer;
